import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  IPermission,
  IGroupPermission,
  IGroupPermissionProps,
} from "./GroupPermissionInterfaces";

export default function GroupPermission({
  group,
  permissions,
  setPermissions,
}: IGroupPermissionProps) {
  const [toggleRender, setToggleRender] = useState<boolean>(false);
  const [localPermission, setLocalPermission] =
    useState<IPermission[]>(permissions);

  useEffect(() => {
    const fetchData = async () => {
      let permissions = await getPermissions();
      await getGroupPermissionsByGroup(permissions);
    };

    fetchData();
  }, []);

  const getPermissions = async () => {
    try {
      let response = await blogFetch.get(`/permission`);
      let data = response.data;
      setLocalPermission(data);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getGroupPermissionsByGroup = async (permissions: IPermission[]) => {
    try {
      let response = await blogFetch.get(`/groupPermissions/${group.group_Id}`);
      let data: IGroupPermission[] = response.data;
      let list: any[] = [];

      for (let i = 0; i < data.length; i++) {
        list.push(data[i].permission.permissions_Id);
      }

      const newCheckList = permissions.map((item) => {
        const container = item;
        if (list.includes(item.permissions_Id)) {
          container["checked"] = true;
        } else {
          container["checked"] = false;
        }

        return container;
      });
   
      setLocalPermission(newCheckList);
      setToggleRender(!toggleRender);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newCheckList = localPermission;
    for (let i = 0; i < newCheckList.length; i++) {
      if (newCheckList[i].permissions_Id?.toString() === event.target.value) {
        newCheckList[i].checked = event.target.checked;
        break;
      }
    }
    setPermissions(newCheckList);
    setLocalPermission(newCheckList);
    setToggleRender(!toggleRender);
  };

  const checkBox = () => {
    return (
      <div>
        <div></div>
        {!!localPermission &&
          localPermission.map((permission) => {
            
            return (
              <FormControlLabel
                key={permission.permissions_Id}
                className="flex items-center"
                style={{
                  width: '22rem',
                  flexWrap: 'wrap'
                }}
                control={
                  <Checkbox
                    checked={permission.checked}
                    onChange={handleCheck}
                    name={permission.permissions_Description}
                    value={permission.permissions_Id}
                  />
                }
                label={
                  <span className="truncate">{permission.permissions_Description}</span>
                }
              />
            );
            
          })}
      </div>
    );
  };

  return (
    <div>
      <h3 style={{ textAlign: "center" }}>Grupos</h3>
      {toggleRender ? checkBox() : <section>{checkBox()}</section>}
    </div>
  );
}
